var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrityImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.775,
    y1: 0.086,
    x2: 0.148,
    y2: 0.829,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dea5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e61c2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3129",
    "data-name": "Rectangle 3129",
    width: 32,
    height: 32,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13699",
    "data-name": "Group 13699",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13051",
    "data-name": "Path 13051",
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    transform: "translate(12 12)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13709",
    "data-name": "Group 13709",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13708",
    "data-name": "Group 13708",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13073",
    "data-name": "Path 13073",
    d: "M3.709,11.064a12.744,12.744,0,0,1,4.874-8.52A11.791,11.791,0,0,1,15.866,0a11.874,11.874,0,0,1,8.249,3.107,12.7,12.7,0,0,1,4.185,7.92c.38.033.744.037,1.1.1a3.276,3.276,0,0,1-.456,6.477c-.125,0-.25.007-.375.007q-12.564,0-25.126.006a3.191,3.191,0,0,1-3.025-1.69,3.275,3.275,0,0,1,2.7-4.864c.187-.006.373,0,.592,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13074",
    "data-name": "Path 13074",
    d: "M30.018,20.024c0,.337.008.693,0,1.049a39.345,39.345,0,0,1-.148,4.1,7.992,7.992,0,0,1-6.86,6.725,7.77,7.77,0,0,1-6.66-2.362,2.276,2.276,0,0,1-.254-.381c-.463.42-.813.788-1.211,1.09a7.514,7.514,0,0,1-8.058,1.021A7.74,7.74,0,0,1,2.06,24.452c-.122-1.471-.021-2.962-.021-4.428ZM9.58,27.046c.524,0,1.048.005,1.573,0a1.228,1.228,0,1,0,.015-2.456q-1.554-.012-3.109,0a1.228,1.228,0,1,0-.015,2.455c.512.008,1.024,0,1.536,0m12.816,0c.524,0,1.049.006,1.573,0a1.228,1.228,0,1,0-.012-2.455q-1.554-.01-3.109,0a1.228,1.228,0,1,0,.012,2.456c.512.006,1.024,0,1.536,0",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrityImg);
export default __webpack_public_path__ + "static/media/integrityImg.c7f107545dcda3408496a157cb8e5a16.svg";
export { ForwardRef as ReactComponent };